import { useIntl } from "react-intl";
import { Spinner, makeStyles } from "@fluentui/react-components";

import TeamsBackground from "@/components/TeamsBackground";

const useStyles = makeStyles({
  spinner: {
    marginTop: "calc(50vh - 32px)",
  },
});

export default function LoadingPage() {
  const { $t } = useIntl();
  const styles = useStyles();
  return (
    <TeamsBackground>
      <Spinner
        className={styles.spinner}
        label={$t({
          defaultMessage: "Loading...",
          description: "Label shown under the spinner while a page loads.",
        })}
        labelPosition="below"
      />
    </TeamsBackground>
  );
}
